import React from 'react';
import PropTypes from 'prop-types';

import { Button, Flexer, Link } from '@ontruck/orc';

import CopyButton from 'modules/Common/Copy/CopyButton';
import { injectIntl } from 'react-intl';

const Actions = ({ assign, copyDetail, viewValidVehicles, fleetOwner, intl }) => {
  const t = intl.messages.modules.journey.detail.journey_info.actions;
  const AssignButton = (
    <Button noWrap ghost text={t.assign} onClick={assign} dataE2E={'detail__assign'} />
  );

  return (
    <>
      <div>
        <Flexer.Parent alignItems="center" flexWrap="wrap" mBottom="S">
          <Flexer.Child mRight="S">{AssignButton}</Flexer.Child>
        </Flexer.Parent>
        <Flexer.Parent alignItems="center">
          <Flexer.Child mRight="S" mBottom="S">
            <CopyButton text={t.copy_details} onClick={copyDetail} />
          </Flexer.Child>
          <Flexer.Child mBottom="S">
            <Link
              noWrap
              skin="secondary"
              text={t.view_matched_vehicles}
              onClick={viewValidVehicles}
              dataE2E={'detail__viewValidVehicles'}
            />
          </Flexer.Child>
        </Flexer.Parent>
        <Flexer.Parent justifyContent="flex-start">
          {t.fleet_owner}: {fleetOwner ? fleetOwner.name : t.no_owner}
        </Flexer.Parent>
      </div>
    </>
  );
};

Actions.propTypes = {
  launched: PropTypes.bool,
  status: PropTypes.string,
  journey: PropTypes.object.isRequired,
  showStatus: PropTypes.bool,
  showNotifyAll: PropTypes.bool,
};

Actions.defaultProps = {
  showNotifyAll: true,
};

export default injectIntl(Actions);
